//basic
import React, { Component } from 'react';
import {toJS} from 'mobx';
import { inject, observer } from 'mobx-react';

//api
import { api } from '../../functions/api';

//style
import '../topProducts/TopProducts.scss';

//custom components
import Search from '../../components/basic/search';
import CustomButton from '../../components/basic/CustomButton';
import CustomTable from '../../components/complex/customTable';
import ChangeSiblingsPositions from '../topProducts/ChangeSiblingsPositions/ChangeSiblingsPositions';
import AddTopProduct from './AddTopProduct/AddTopProduct';
import DeleteDialog from '../../components/global/deleteDialog';

//material-ui
import { CircularProgress, FormControl, InputLabel, Select, MenuItem  } from '@material-ui/core';

//other libraries
import queryString from 'query-string';
import Icon from '@mdi/react';
import { mdiPlus } from '@mdi/js';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';

const materialTheme = createMuiTheme({
    typography: {
        useNextVariants: true,
    },
    overrides: {
        MuiInput: {
            underline: {
                "&::after": {
                    borderBottomColor: "#777777",
                    borderBottom: "2px solid #777777 !important"
                }
            },
        },
        MuiFormControl: {
            root: {
                marginLeft: "2px",
                marginRight: "5px",
                marginTop: "20px"
            }
        }
    }
})

@inject('internal')
@inject('translate')
@observer
export default class TopProducts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingPage: true,
            loadingTable: true,
            siblingsDialog: false,
            addTopProductDialog: false,
            shop_id: 2,
        }
    }

    // definujeme ci sa ma reloadnut tabulka
    tableReload = false;

    // counter ktori sa zvacsuje pri kazdom api cale okrem pri mounte modulu
    // nedovuje aby sa tabulka zobrazila skor ako co pride aj posledna odpoved zo servera
    apiCallCounter = 0;

    tableHeader = [
        {
            "title": "title",
            "numeric": false,
            "min_width": "150px",
            
        },
        // {
        //     "title": "frontend_link",
        //     "numeric": false
        // },
        // {
        //     "title": "backend_link",
        //     "numeric": false,
        //     "min_width": "100px"
        // },
        {
            "title": "position",
            "numeric": false,
            "textAlign": "center"
        }
    ];
    tableBody = [
        "name",
        // "code",
        // "name",
        "id"
    ]

    dropDownMenuItems = [
        {
            title: this.props.translate.i18n.GLOBAL.BUTTONS.SHOW_ESHOP,
            action: 'top-products'
        },
        {
            title: this.props.translate.i18n.MODULES.ADMINISTRATORS.MENU_ITEMS.EDIT,
            redirect: "system"
        },
        // {
        //     title: this.props.translate.i18n.GLOBAL.BUTTONS.DELETE,
        //     action: "delete"
        // },
    ];

    componentDidMount() {
        this.setState({shop_id: Number(this.props.match.params.idShop)})

        const { user } = toJS(this.props.internal)

        if(user && user.data && user.data.permissions && user.data.permissions.top_products && user.data.permissions.top_products.view) {
            this.props.internal.setRoute( this.props.history, this.props.location.pathname);
            this.props.internal.setHeaderTitle(this.props.translate.i18n.GLOBAL.MENU.TOP_PRODUCTS);
            this.setPermissions()
            this.loadTopProducts();
            // this.addQueryToUrl("shop_id", "1");
        }
        else {
            this.props.internal.setRoute(this.props.history, this.props.location.pathname)
            this.props.internal.pushRoute('/')
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.NOT_PERMISSIONS, true)
        }
    }
    

    componentWillReceiveProps() {
        if(Number(this.props.match.params.idShop) !== this.state.shop_id) {
            this.setState({shop_id: Number(this.props.match.params.idShop), loadingPage: true})
            this.loadTopProducts()
        }
    }

    setPermissions() {
        const { user } = toJS(this.props.internal)

        if(user && user.data && user.data.permissions && user.data.permissions.top_products && user.data.permissions.top_products.update) {
            this.dropDownMenuItems.push(
                {
                    title: this.props.translate.i18n.GLOBAL.BUTTONS.DELETE,
                    action: "delete"
                },
            )
        }
    }

    handleChangeRowsPerPage = (size) => {
        this.setState({
            loading: true
        });
        this.addQueryToUrl("page_size", size)
    }

    handleChangePage = (page) => {
        this.setState({
            loading: true
        });

        this.addQueryToUrl("page_number", page + 1)
    }

    handleSearch = (searchTerm) => {

        if (searchTerm.length > 2) {
            this.tableReload = true;
            this.addQueryToUrl("searchterm", searchTerm)
        }
        else {
            this.addQueryToUrl("searchterm", "")
        }
    }

    handleSort = (dir, orderBy) => {
        this.setState({
            loading: true
        })
        this.addQueryToUrl("dir", dir,"by", orderBy)
    }

    addQueryToUrl = (param, value, param2 = null, value2 = null) => {
        this.tableReload = true;

        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString)
        queries[param] = value
        if(param2 && value2) {
            queries[param2] = value2
        }

        let new_path = this.props.location.pathname

        new_path += "?"
        for(let key in queries) {
            if(key) {
                new_path += key + "=" + queries[key] + "&"
            }
        }
        new_path = new_path.slice(0,-1)

        this.props.internal.pushRoute(new_path)
        this.loadTopProducts()
    }

    loadTopProducts = async(size = 10, page = 0, searchterm = "", by = "name", dir = "asc") => {
        if(this.tableReload) {
            this.setState({loadingTable: true})
            this.apiCallCounter++;
        }
        
        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString);

        let shop_id = "";
        let filters = {};
        let params = {};

        // shop_id = 2;
        shop_id = Number(this.props.match.params.idShop)
        filters.shop_id = shop_id
        params.filters = filters

        if(queries) {
            
            if(queries.page_number) {
                page = queries.page_number
            }

            if(queries.page_size) {
                size = queries.page_size
            }

            if(queries.by) {
                by = queries.by
            }

            if(queries.dir) {
                dir = queries.dir
            }

            if(queries.searchterm) {
                searchterm = queries.searchterm
            }

            if(queries.shop_id) {
                shop_id = queries.shop_id;
                filters.shop_id = shop_id
                params.filters = filters
            }
        }

        let load_data = await api({
            method:'get',
            url: 'products/top',
            authorization: this.props.internal.user.access_token,
            params: params
            // params:{
            //     searchterm: searchterm,
            //     page:{
            //         number:page,
            //         size:size,
            //     },
            //     order: [
            //         {
            //             by: by,
            //             dir: dir
            //         }
            //     ]
            // }
        })


        if (load_data.success === true) {
            if (load_data.data) {
                this.props.internal.setDataForTable(load_data.data)
                this.setState({loadingTable: false})
            }
        }
        this.setState({loadingPage: false})

        if(this.tableReload) {
            this.apiCallCounter--;
            if(this.apiCallCounter === 0) {
                this.setState({loadingTable: false})
                this.tableReload = false;
            }
        }
    }

    openCloseDialogChangePosition = () => {
        this.setState({siblingsDialog: !this.state.siblingsDialog})
        this.loadTopProducts()
    }

    handleOpenCloseDialog = () => {
        this.setState({addTopProductDialog: !this.state.addTopProductDialog})
        this.loadTopProducts()
    }

    handleDelete = async () => {
        let idProduct = toJS(this.props.internal.actionDeleteObj.id)
        let delete_top_product = await api({
            method: 'patch',
            url: "products/top/toggle",
            authorization: this.props.internal.user.access_token,
            params: {
                product_id: idProduct,
                // is_top: false,
                shop_id: this.state.shop_id
            }
        });

        if(delete_top_product.success === true) {
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.SUCCESS_UPDATE, true)
            this.loadTopProducts();
            this.props.internal.setActionDelete();
        }
    }

    handleChangeShop = shop_id => {
        this.setState({shop_id: shop_id.target.value})
        this.addQueryToUrl("shop_id", shop_id.target.value)
    }

    render () {
        const { user } = toJS(this.props.internal)
        return (
            this.state.loadingPage
                ?
                <CircularProgress className={'circular-progress'}/>
                :
                <div className={'top-products'}>
                    {/* zmena poradia top prvkov */}
                    <ChangeSiblingsPositions
                        open={this.state.siblingsDialog}
                        onClose={this.openCloseDialogChangePosition}
                        title={this.props.translate.i18n.MODULES.CATEGORIES.DIALOG_TITLE_CHANGE_SIBLINGS_POSITIONS}
                        childs={this.props.internal.dataForTable.data}
                    />
                    <DeleteDialog
                        open={this.props.internal.actionDelete}
                        title={this.props.translate.i18n.MODULES["TOP-PRODUCTS"].DELETE_TOP_PRODUCTS_TITLE}
                        content={this.props.translate.i18n.GLOBAL.ALERTS.DELETE_ITEM}
                        btn_cancel={this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                        btn_delete={this.props.translate.i18n.GLOBAL.BUTTONS.DELETE}
                        delete={this.handleDelete}
                    />
                    {this.state.addTopProductDialog &&
                        <AddTopProduct
                            open={this.state.addTopProductDialog}
                            onClose={this.handleOpenCloseDialog}
                            title={this.props.translate.i18n.MODULES['TOP-PRODUCTS'].DIALOG_TITLE_ADD_TOP_PRODUCT}
                            shop={this.state.shop_id}
                        />
                    }
                    <div className={'flex space-between'}>
                        <Search placeholder={this.props.translate.i18n.MODULES.MENU.SEARCH} classes={'admin-search'} onChange={this.handleSearch} value={this.state.searchTerm}/>
                        {user && user.data && user.data.permissions && user.data.permissions.top_products && user.data.permissions.top_products.update ?
                            <CustomButton
                                mystyle = {'btn-orange-bg border-radius-18'}
                                title = {this.props.translate.i18n.MODULES["TOP-PRODUCTS"].ADD_NEW_TOP_PRODUCT}
                                onClick = {this.handleOpenCloseDialog}
                            >
                                <Icon path = {mdiPlus} size = {1}/>
                            </CustomButton>
                            :
                            null
                        }
                    </div>
                    {/* <MuiThemeProvider theme={materialTheme}>
                        <FormControl className="select-type-position">
                            <InputLabel
                                htmlFor="select-shop"
                                className={"label-select-type"}
                                // shrink={true}
                            >
                                {this.props.translate.i18n.MODULES.MENU.SHOP}
                            </InputLabel>
                            <Select
                                classes={{
                                    root: "select-menu-position-root",
                                }}
                                value={this.state.shop_id}
                                onChange={this.handleChangeShop}
                                inputProps={{
                                    name: "select-shop",
                                    id: "select-shop",
                                }}
                                // displayEmpty
                            >
                                {toJS(this.props.internal.dataForTable.lists.shops).map((shop, index) => {
                                    return (<MenuItem key={index} value={shop.id}>{shop.name}</MenuItem>);
                                })}
                            </Select>
                        </FormControl>
                    </MuiThemeProvider> */}
                    {this.state.loadingTable
                        ?
                        <CircularProgress className={'circular-progress'} />
                        :
                        // null
                        <CustomTable
                            dropDownMenuItems={this.dropDownMenuItems}
                            module={'/top-products'}
                            handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                            handleChangePage={this.handleChangePage}
                            handleSort={this.handleSort}
                            header={this.tableHeader}
                            body={this.tableBody}
                            openDialogSiblings={this.openCloseDialogChangePosition}
                            handleChangeType={this.handleChangeType}
                            disablePagination={true}
                        />
                    }
                </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/screens/topProducts/TopProducts.jsx